export function stripNullValues(value: any): any {
    if (value === null || value === undefined) {
        return undefined;
    }
    if (typeof value !== 'object' || Array.isArray(value)) {
        return value;
    }
    const result: Record<string, any> = {};
    for (const [ key, val ] of Object.entries(value)) {
        if (val !== null) {
            result[key] = typeof val === 'object' && !Array.isArray(val) ? stripNullValues(val) : val;
        }
    }
    return result;
}
